(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var core = window.HBSub02;
    var data = JSON.parse(root.querySelector('[data-sub02-data]').textContent);
    var opts = Array.from(root.querySelectorAll('.opt'));
    var checkbox = root.querySelector('[data-sub02-checkbox]');
    var frequency = root.querySelector('[data-sub02-frequency]');
    var refill = root.querySelector('[data-sub02-refill]');
    var error = root.querySelector('[data-sub02-error]');
    var atc = root.querySelector('.atc');
    var p2p = root.closest('[data-hb-p2p-buy]');
    var selected = root.querySelector('.opt.sel') || opts[0];
    var pack = function (opt) { return data.packs.find(function (p) { return p.id === Number(opt.dataset.variantId); }); };
    function fit() {
      var measure = document.createElement('span');
      measure.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;font:inherit;font-weight:500';
      frequency.parentNode.appendChild(measure);
      measure.textContent = frequency.selectedOptions[0].text;
      frequency.style.width = Math.ceil(measure.getBoundingClientRect().width + 11) + 'px';
      measure.remove();
    }
    function render() {
      refill.classList.toggle('on', checkbox.checked);
      opts.forEach(function (opt) {
        var item = pack(opt), state = core.evaluate(item, frequency.value, checkbox.checked);
        // Never invent a discounted price when that pack has no valid allocation.
        opt.querySelector('.now').textContent = state.error ? item.formatted : state.formatted;
        opt.querySelector('.ea').textContent = (state.error ? item.unit : state.unit) + '/tube';
        if (item.freeShipping) {
          var ship = document.createElement('span');
          ship.className = 'ship'; ship.textContent = 'Free shipping';
          opt.querySelector('.ea').appendChild(document.createTextNode(' · '));
          opt.querySelector('.ea').appendChild(ship);
        }
        var current = state.error ? item.price : state.price;
        var was = opt.querySelector('.was'), save = opt.querySelector('.sv');
        was.textContent = item.compare > current ? item.compareFormatted : '';
        was.classList.toggle('show', item.compare > current);
        save.textContent = item.compare > current ? 'SAVE ' + Math.round(100 * (1 - current / item.compare)) + '%' : '';
        save.classList.toggle('show', item.compare > current);
      });
      var state = core.evaluate(pack(selected), frequency.value, checkbox.checked);
      error.textContent = state.error || '';
      error.hidden = !state.error;
      atc.disabled = !!state.error;
      if (p2p) {
        var label = p2p.querySelector('[data-sc-lbl]'), now = p2p.querySelector('[data-sc-now]'), was = p2p.querySelector('[data-sc-was]');
        if (label) label.textContent = pack(selected).qty + (pack(selected).qty === 1 ? ' Tube' : ' Tubes');
        if (now) now.textContent = selected.querySelector('.now').textContent;
        if (was) { was.textContent = selected.querySelector('.was').textContent; was.hidden = !was.textContent; }
      }
    }
    function select(opt) {
      selected = opt;
      opts.forEach(function (o) { o.classList.toggle('sel', o === opt); o.setAttribute('aria-checked', String(o === opt)); });
      frequency.replaceChildren();
      core.required(pack(opt).qty).forEach(function (weeks) {
        var option = document.createElement('option');
        option.value = String(weeks); option.textContent = weeks + ' weeks';
        option.disabled = !core.allocation(pack(opt), weeks);
        frequency.appendChild(option);
      });
      frequency.value = '4';
      fit(); render();
    }
    opts.forEach(function (opt) {
      opt.setAttribute('role', 'radio'); opt.tabIndex = 0;
      opt.addEventListener('click', function () { select(opt); });
      opt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(opt); } });
    });
    checkbox.addEventListener('change', render);
    frequency.addEventListener('change', function () { checkbox.checked = true; fit(); render(); });
    atc.addEventListener('click', async function () {
      if (atc.disabled) return;
      var body;
      try { body = core.payload(pack(selected), frequency.value, checkbox.checked); }
      catch (e) { error.textContent = e.message; error.hidden = false; return; }
      atc.disabled = true;
      var label = atc.textContent, base = (window.Shopify && Shopify.routes.root) || '/';
      atc.textContent = 'ADDING…';
      try {
        var response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        var added = await response.json();
        if (!response.ok) throw new Error(added.description || added.message || 'Could not add to cart.');
        var cartResponse = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Added to cart. Please open your bag to view it.');
        var cart = await cartResponse.json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      } catch (e) { error.textContent = e.message; error.hidden = false; }
      finally { atc.textContent = label; atc.disabled = !!core.evaluate(pack(selected), frequency.value, checkbox.checked).error; }
    });
    select(selected);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }
  function boot() { document.querySelectorAll('[data-hb-sub02]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
}());

// Keep chat accessible without the unsolicited label covering this preview.
(function () {
  'use strict';
  if (typeof document === 'undefined' || window.hbPreviewChatClearance) return;
  if (!document.querySelector('[data-hb-sub02],[data-hb-pdp]')) return;
  window.hbPreviewChatClearance = true;
  var styleHash, lastOffset = null, queued = false;
  function updateChatClearance() {
    queued = false;
    var api = window.tidioChatApi;
    if (!api || typeof api.adjustStyles !== 'function') return;
    var offset = 0;
    if (window.innerWidth < 1024) {
      document.querySelectorAll('.stickycta.show,[data-pagesmith-sticky].on').forEach(function (sticky) {
        var rect = sticky.getBoundingClientRect();
        if (rect.height > 0) offset = Math.max(offset, Math.ceil(rect.height + 12));
      });
    }
    if (offset === lastOffset) return;
    try {
      var nextHash = api.adjustStyles('.widgetLabel{display:none!important;}#button{translate:0 -' + offset + 'px!important;}');
      if (styleHash && typeof api.removeStyles === 'function') api.removeStyles(styleHash);
      styleHash = nextHash;
      lastOffset = offset;
    } catch (error) { /* Retry on the widget-ready event if it is still loading. */ }
  }
  function scheduleChatClearance() {
    if (!queued) { queued = true; requestAnimationFrame(updateChatClearance); }
  }
  window.addEventListener('scroll', scheduleChatClearance, { passive: true });
  window.addEventListener('resize', scheduleChatClearance);
  document.addEventListener('tidioChat-ready', scheduleChatClearance);
  if (window.tidioChatApi) window.tidioChatApi.on('ready', scheduleChatClearance);
  new MutationObserver(scheduleChatClearance).observe(document.querySelector('[data-hb-sub02]')?.closest('[data-hb-p2p-buy]') || document.querySelector('[data-hb-pdp]'), { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  scheduleChatClearance();
}());
